import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { setPlaceInfo } from "redux/Actions";
import { IPlaceData } from "types/Place";
import { fetchAPIPlace } from "../requests/Place";

export function useQueryPlace(id: number) {
    const dispatch = useDispatch();
    const onError = () => {};
    const query = useQuery("apiPlace", async () => await fetchAPIPlace(id), { onSuccess: (data) => {
        if(data?.success) {
            let placeInfo: IPlaceData = data?.data;
            dispatch(setPlaceInfo(placeInfo));
        } else {
            // console.log(data?.errors)
        }
    }, onError });
    return query;
}
